export const conciliationStatus = {
  REJECTED: 'Rechazado',
  ACCEPTEDSETTLEMENTCOMPLETED: 'Aceptado',
  PAGADO: 'Pagado',
} as const;
